var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCareerEcoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 39,
    viewBox: "0 0 33 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0L0 9.54008V28.5769L16.5 38.117L33 28.5769V9.54008L16.5 0Z",
    fill: "#E75541"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 9.54008L16.5 0L0 9.54008L16.5 19.0585L33 9.54008Z",
    fill: "#B03428"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5014 19.0581H24.5888C24.5888 14.5916 20.9679 10.9707 16.5014 10.9707C12.035 10.9707 8.41406 14.5916 8.41406 19.0581C8.41406 23.5246 12.035 27.1455 16.5014 27.1455V19.0581Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerEcoLogo);
export default __webpack_public_path__ + "static/media/career-eco-logo.0ba08b7a8b5c0fcb27c9a54897922c6e.svg";
export { ForwardRef as ReactComponent };